import { type AppState } from '~/store/app.store';

export const myLocationTrackingEnabledSelector = (state: AppState) => state.frontendState.mapTools.myLocation.enabled;

export const myLocationSelector = (state: AppState) => myLocationTrackingEnabledSelector(state) ? state.frontendState.mapTools.myLocation.latLng : null;

export const myLocationErrorSelector = (state: AppState) => myLocationTrackingEnabledSelector(state) && state.frontendState.mapTools.myLocation.error;

export const myLocationLoadingSelector = (state: AppState) => myLocationTrackingEnabledSelector(state) && !myLocationErrorSelector(state) && !state.frontendState.mapTools.myLocation.latLng;
